import { render } from "./MentionInput.vue?vue&type=template&id=0b3fde94&scoped=true&ts=true"
import script from "./MentionInput.vue?vue&type=script&lang=ts"
export * from "./MentionInput.vue?vue&type=script&lang=ts"

import "./MentionInput.vue?vue&type=style&index=0&id=0b3fde94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3fde94"]])

export default __exports__